import React, { useState, useEffect, useCallback } from 'react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { resolveAssetUrl } from '../../lib/assets';
import { ChevronLeft, ChevronRight } from 'lucide-react';

// Fullscreen image viewer for public pages.
// Pass `value` = { images: string[], index: number } or null (null = closed).
export const ImageLightbox = ({ value, onClose }) => {
  const images = (value && Array.isArray(value.images)) ? value.images.filter(Boolean) : [];
  const open = images.length > 0;
  const [i, setI] = useState(0);

  useEffect(() => {
    if (open) setI(Math.min(Math.max(value.index || 0, 0), images.length - 1));
  }, [value]); // eslint-disable-line react-hooks/exhaustive-deps

  const go = useCallback((d) => setI((p) => (p + d + images.length) % images.length), [images.length]);

  useEffect(() => {
    if (!open) return undefined;
    const h = (e) => {
      if (e.key === 'ArrowRight') go(1);
      else if (e.key === 'ArrowLeft') go(-1);
    };
    window.addEventListener('keydown', h);
    return () => window.removeEventListener('keydown', h);
  }, [open, go]);

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent
        className="p-0 bg-transparent border-0 shadow-none w-[94vw] max-w-4xl flex items-center justify-center"
        data-testid="image-lightbox">
        {open && (
          <div className="relative w-full flex items-center justify-center">
            <img src={resolveAssetUrl(images[i])} alt=""
              className="w-full max-h-[85vh] object-contain rounded-xl select-none"
              data-testid="lightbox-image" />
            {images.length > 1 && (
              <>
                <button type="button" onClick={() => go(-1)} aria-label="Iepriekšējā" data-testid="lightbox-prev"
                  className="absolute left-2 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-black/60 text-white flex items-center justify-center hover:bg-black/80 transition-colors">
                  <ChevronLeft className="w-6 h-6" />
                </button>
                <button type="button" onClick={() => go(1)} aria-label="Nākamā" data-testid="lightbox-next"
                  className="absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-black/60 text-white flex items-center justify-center hover:bg-black/80 transition-colors">
                  <ChevronRight className="w-6 h-6" />
                </button>
                <div className="absolute bottom-3 left-1/2 -translate-x-1/2 px-3 py-1 rounded-full bg-black/60 text-white text-xs font-medium" data-testid="lightbox-counter">
                  {i + 1} / {images.length}
                </div>
              </>
            )}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
